export default __webpack_public_path__ + "static/media/musicplayer.01955f83.png";